import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Modal,
  Row,
  Table,
} from 'reactstrap';
import { CircularProgress } from '@material-ui/core';

import formatCurrency from 'utils/formatCurrency';
import { PropostaVersao } from 'models/PropostaVersao';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';
import { PropostaVersaoParcelas } from 'models/PropostaVersaoParcelas';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
import {
  FaCalculator,
  FaCheck,
  FaPlusCircle,
  FaSave,
  FaSpinner,
  FaTrash,
} from 'react-icons/fa';
import arredondaCentesimal from 'utils/arredondaCentesimal';
import { PropostaMeioPagamento } from 'models/PropostaMeioPagamento';
import BancoFinanciamento from 'models/BancoFinanciamento';
import PropostaLinhaCredito from 'models/PropostaLinhaCredito';
import Parametros from 'models/Parametros';
import FloatingButton from 'components/FloatingButton';
import { TipoArredondamento } from 'utils/TipoArredondamento';
import PrecificacaoModel from 'models/PrecificacaoModel';
import { Th, Td } from './styles';
import { PropostaContext } from '../..';
import Cabecalho from './components/Cabecalho';
import Desconto from './components/Desconto';
import MeioPagamento from './components/MeioPagamento';
import VariaveisComerciais from './components/VariaveisComerciais';
import Parcelas from './components/Parcelas';
import PrazoMedio from './components/PrazoMedio';
import Resumo from './components/Resumo';

registerLocale('pt-BR', ptBr);

export interface iPropostaDados {
  isExterior: boolean;
  propostaVersaoId: number;
  codigoIncentivo?: string;
  dataCriacao: Date;
  valores: {
    valorFinal: number;
    valorFinalParcelas: number;
    valorFinalComOutros: number;
    valorFinalDolar: number;
    valorFrete: number;
    valorItens: number;
    valorDesconto: number;
    valorDespesaDespachante: number;
    valorLicenciamento: number;
    valorOutros: number;
    valorSeguroFrete: number;
    valorTopografia: number;
    motivoOutros: number;
    valorServico: number;
    desconto: number;
    descontoOriginal: number;
    comissao: number;
    valorSubFinal: number;
    percentualFrete: number;
    percentualLicenciamento: number;
    percentualTopografia: number;
    percentualAssistenciaTecnica: number;
    percentualAssistenciaTecnicaOriginal: number;
    assistenciaTecnicaAlterada: number;
    percentualOutros: number;
    percentualTaxaFlat: number;
    percentualAcessoriaRemota: number;
    percentualComissao: number;
    percentualAjusteComissao: number;
    percentualIndicadorNegocio: number;
    percentualComissaoReceber: number;
    percentualServicos: number;
    percentualICMS: number;
    percentualPISCofins: number;
    percentualIPI: number;
    percentualST: number;
    valorDolar: number;
    descontoAprovado: boolean;
    dataEmbarque?: any | undefined;
    percentualSeguroEngenharia: number | null;
    percentualSeguroExecucao: number | null;
    percentualSeguroGarantia: number | null;
    percentualRespCivil: number | null;
    percentualRiscosTrabal: number | null;
    valorRespCivil: number | null;
    valorRiscosTrabal: number | null;
    valorSeguroEngenharia: number | null;
    valorSeguroExecucao: number | null;
    valorSeguroGarantia: number | null;
  };
  usuario: {
    isIsentoComissao: boolean;
    percentualAcrescimoProposta: number;
    percentualAssistenciaTecnicaProposta: number;
  };
  meioPagamento: {
    bancoProposta: string;
    meioPagamento: number;
    formatoBanco?: string;
    linhaCredito?: number | null;
    banco?: string;
  };
  aprovacao: {
    parcelaAprovada: boolean;
    descontoAprovado: boolean;
  };
  variaveisComerciais: {
    difalPorConta: string;
    formatoMaoObra: string;
    custoFinanceiro: number;
  };
  precificacao: PrecificacaoModel[];
  parcelas: {
    id: number;
    meioPagamentoId: number;
    dataPrevista?: Date | null | string;
    percentual: number;
    valor: number;
    observacao: string;
    setorAtividade?: string | null;
    dias?: string | null;
    createdAt?: Date;
    idTemp?: string | null; // esse ID só existe no frontend para controle das parcelas
  }[];
  parcelasPorSetorAtiv?: any[];
  metas: {
    tipoMeta: string;
    metaValor?: number;
    metaDesconto?: number;
  };
  outros: {
    propostaConfiguracaoId?: number;
    divisaoProduto?: string;
    tipo?: string;
    configuracaoId?: number;
    tipoImportacaoId?: number | null;
    produtoId?: number;
    isRegramentoGeral: boolean;
    isParcelamentoEspecial: boolean;
    temIncentivoFIscal: boolean;
    tipoArredondamento: TipoArredondamento;
  };
}

export interface iComboList {
  name: string;
  value: string;
}

// export interface iListaTaxaFlat {
//   banco: string;
//   formato: string;
//   taxa: number;
// }

export interface iListaTaxaFlat {
  codigoBanco: string;
  // bancoCodigo: string;
  formato: string;
  percTaxa: number;
}

export interface iAcessoPrograma2 {
  programa: number;
  acessoLimitado: boolean;
  temAcesso: boolean;
}

interface iAcesso {
  acessoLimitado: boolean;
  temAcesso: boolean;
}

export interface iAcessoPrograma {
  difal: iAcesso;
  variaveisComerciais: iAcesso;
  taxaFlat: iAcesso;
  custoFinanceiro: iAcesso;
  comissao: iAcesso;
  acessoriaRemota: iAcesso;
}

export default function Precificacao({
  isRegramentoGeral,
  tipoGerar,
}: {
  isRegramentoGeral: boolean;
  tipoGerar: string;
}): JSX.Element {
  const { carregaPropostaVersao, propostaVersao } = useContext(PropostaContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [enableSaveButton, setEnableSaveButton] = useState(false);

  const [isModoSimulacao, setIsModoSimulacao] = useState(false);
  const [isBasicDataLoaded, setIsBasicDataLoaded] = useState(false);
  const [informacaoProposta, setInformacaoProposta] =
    useState<iPropostaDados>();

  const [parametros, setParametros] = useState<Parametros>();

  const [informacaoPropostaOriginal, setInformacaoPropostaOriginal] =
    useState<iPropostaDados>();

  const [meioPagamentos, setMeioPagamentos] = useState<PropostaMeioPagamento[]>(
    [],
  );

  const [bancosFinanciamento, setBancoFinanciamento] = useState<
    BancoFinanciamento[]
  >([]);

  const [propostaLinhaCredito, setPropostaLinhaCredito] = useState<
    iComboList[]
  >([]);

  const [listaDifal, setListaDifal] = useState<iComboList[]>([]);

  const [listaTaxaFlat, setListaTaxaFlat] = useState<iListaTaxaFlat[]>([]);

  const [formatoBanco, setFormatoBanco] = useState<iComboList[]>([]);

  const [ordemSalvaVersion, setOrdemSalvaVersion] = useState(0);

  const [erroPosSalvar, setErroPosSalvar] = useState(false);

  const [acessoProgramas, setAcessosProgramas] = useState<iAcessoPrograma>({
    difal: {
      acessoLimitado: true,
      temAcesso: false,
    },
    custoFinanceiro: {
      acessoLimitado: true,
      temAcesso: false,
    },
    comissao: {
      acessoLimitado: true,
      temAcesso: false,
    },
    taxaFlat: {
      acessoLimitado: true,
      temAcesso: false,
    },
    variaveisComerciais: {
      acessoLimitado: true,
      temAcesso: false,
    },
    acessoriaRemota: {
      acessoLimitado: true,
      temAcesso: false,
    },
  });

  function formatEAdicaoDias(dateString: string, days: number): Date {
    const date = new Date(dateString);
    date.setDate(date.getDate() + days);
    return date;
  }
  async function getAcessoPrograma() {
    const response = await api.get('/acesso-programa/acesso-programa-lote', {
      params: {
        programas: [61, 74, 28, 131, 132, 136],
      },
    });

    // 61 - setAcessoLimitadoVariaveisComerciais
    // 74 - setAcessoLimitadoControleTaxaFlat
    // 28 - Acesso limitado difal

    const lista = response.data as iAcessoPrograma2[];

    const novoAcesso = acessoProgramas;

    const buscarDifal = lista.find(item => item.programa === 28);
    const buscarVariaveis = lista.find(item => item.programa === 61);
    const buscarFlat = lista.find(item => item.programa === 74);
    const buscarCustoFinanceiro = lista.find(item => item.programa === 131);
    const buscarComissao = lista.find(item => item.programa === 132);
    const buscarAcessoriaRemota = lista.find(item => item.programa === 136);

    if (buscarDifal) {
      novoAcesso.difal.acessoLimitado = buscarDifal.acessoLimitado;
      novoAcesso.difal.temAcesso = buscarDifal.temAcesso;
    }

    if (buscarCustoFinanceiro) {
      novoAcesso.custoFinanceiro.acessoLimitado =
        buscarCustoFinanceiro.acessoLimitado;
      novoAcesso.custoFinanceiro.temAcesso = buscarCustoFinanceiro.temAcesso;
    }

    if (buscarComissao) {
      novoAcesso.comissao.acessoLimitado = buscarComissao.acessoLimitado;
      novoAcesso.comissao.temAcesso = buscarComissao.temAcesso;
    }

    if (buscarVariaveis) {
      novoAcesso.variaveisComerciais.acessoLimitado =
        buscarVariaveis.acessoLimitado;
      novoAcesso.variaveisComerciais.temAcesso = buscarVariaveis.temAcesso;
    }

    if (buscarFlat) {
      novoAcesso.taxaFlat.acessoLimitado = buscarFlat.acessoLimitado;
      novoAcesso.taxaFlat.temAcesso = buscarFlat.temAcesso;
    }

    if (buscarAcessoriaRemota) {
      novoAcesso.acessoriaRemota.acessoLimitado =
        buscarAcessoriaRemota.acessoLimitado;
      novoAcesso.acessoriaRemota.temAcesso = buscarAcessoriaRemota.temAcesso;
    }

    setAcessosProgramas(novoAcesso);
  }

  async function dadosProposta() {
    const response = await api.get(
      `/proposta-precificacao/versao/${propostaVersao.id}`,
    );

    console.log('DADOS DA PROPOSTA VERSAO: ', response.data);

    const proposta = response.data as iPropostaDados;

    // Set default dataEmbarque if missing
    if (!proposta.valores.dataEmbarque) {
      proposta.valores.dataEmbarque = formatEAdicaoDias(
        String(proposta.dataCriacao),
        90,
      );
    }

    setInformacaoProposta(proposta);
    setInformacaoPropostaOriginal(proposta);
  }

  async function dadosMeioPagamento() {
    const response = await api.get(`/proposta/meio-pagamento`);
    setMeioPagamentos(response.data as PropostaMeioPagamento[]);
  }

  async function dadosBanco() {
    // const response = await api.get(`/integracao/banco`);
    console.log('proposta-banco 1');
    const response = await api.get(`/proposta-banco/`);
    console.log('proposta-banco 1: ', response.data);
    setBancoFinanciamento(response.data as BancoFinanciamento[]);
  }

  async function dadosParametros() {
    const response = await api.get(`/parametros`);

    setParametros(response.data as Parametros);
  }

  async function dadosLinhaCredito() {
    const response = await api.get(`/proposta-linha-credito`);
    const dados = response.data as PropostaLinhaCredito[];
    setPropostaLinhaCredito(
      dados.map((item: PropostaLinhaCredito) => {
        return { name: item.nome, value: String(item.id) } as iComboList;
      }),
    );
  }

  async function dadosListaFlat() {
    // const response = await api.get('integracao/banco/flat', {});
    console.log('banco-taxa/flat');
    const response = await api.get('/banco-taxa/flat');
    console.log('banco-taxa/flat: ', response.data);
    setListaTaxaFlat(response.data as iListaTaxaFlat[]);
  }

  async function dadosFormatoBanco() {
    const formatosBanco: iComboList[] = [
      { name: 'BROTO', value: 'BROTO' },
      { name: 'CONVENCIONAL', value: 'CONVENCIONAL' },
      { name: 'ESTEIRA', value: 'ESTEIRA' },
      { name: 'FCO', value: 'FCO' },
      { name: 'CDC', value: 'CDC' },
      { name: 'FEIRA', value: 'FEIRA' },
    ];

    setFormatoBanco(formatosBanco);
  }

  async function dadosDifal() {
    const difalOptions: iComboList[] = [
      { name: 'do Cliente', value: 'do Cliente' },
      { name: 'da Fockink', value: 'da Fockink' },
    ];

    setListaDifal(difalOptions);
  }

  async function carregarDados(onlyProposta = false) {
    try {
      Swal.fire({
        icon: 'info',
        text: `Buscando dados de precificação da proposta`,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
      });

      if (!onlyProposta) {
        await dadosParametros();
        await dadosMeioPagamento();
        await dadosBanco();
        await dadosLinhaCredito();
        await dadosFormatoBanco();
        await dadosListaFlat();
        await dadosDifal();
        await getAcessoPrograma();
      }
      await dadosProposta();

      setIsBasicDataLoaded(true);
    } finally {
      Swal.close();
    }
  }

  useEffect(() => {
    if (!isBasicDataLoaded) {
      carregarDados();
    }
  }, [isBasicDataLoaded]);

  async function handleSimulationMode(open: boolean) {
    if (open) {
      setInformacaoPropostaOriginal(informacaoPropostaOriginal);
      setIsModoSimulacao(open);
    } else {
      const valor = await Swal.fire({
        title: `Sair modo simulação`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
                Você está no modo de simulação. Quaisquer alterações serão perdidas. A tela será atualizada para mostrar os dados originais. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      });

      if (valor.isConfirmed) {
        setIsModoSimulacao(false);
        // Define o objeto atual como o item que foi salvo no Original
        // Sem necessidade de reload.
        // Mas, caso precise, basta chamar o carregarDados(true);
        setInformacaoProposta(informacaoPropostaOriginal);
      }
    }
  }

  async function handleSalvar(podeDispararAprovacao = false) {
    try {
      Swal.fire({
        icon: 'info',
        text: `Salvando informações da proposta`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      const isParcelamentoEspecial = (informacaoProposta?.parcelas ?? []).some(
        item => (item.valor ?? 0) > 0,
      );

      const response = await api.post(
        `/proposta-precificacao/versao/${propostaVersao.id}/salvar`,
        {
          dados: informacaoProposta,
          // Desativando por enquanto, estava causando alguns problemas de aprovação de proposta.
          /* podeDispararAprovacao: isParcelamentoEspecial
            ? true
            : podeDispararAprovacao, */
          podeDispararAprovacao,
          metaDesconto: informacaoProposta?.metas.metaDesconto,
          metaValor: informacaoProposta?.metas.metaValor,
        },
      );
      const temAprovacao = response.data.possuiAprovacao as boolean;

      if (temAprovacao) {
        const valor = await Swal.fire({
          title: `Aprovações necessárias`,
          html: `<div style='text-align: justify!important; text-justify: inter-word;'>
                  <p>Algumas informações estão fora do permitido. Sendo necessárias passarem por fluxo de aprovação:</p>
                  ${response.data.mensagem ?? ''}
                  <br /><br /><p>Deseja prosseguir com o salvamento?</p></div>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: `Sim, prosseguir`,
          confirmButtonColor: '#d33',
          cancelButtonText: `Não`,
        });

        if (valor.isConfirmed) {
          await handleSalvar(true);
        }
      } else {
        await carregarDados(true);
        setIsModoSimulacao(false);
        carregaPropostaVersao();
        toast.success('Informações salvas com sucesso');
      }

      setOrdemSalvaVersion(prev => prev + 1);

      Swal.close();
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    }
  }

  function pegarNomeEquipamento(equipamento: any): string {
    if (equipamento.tipo === 'C') {
      return `${equipamento.titulo} - #${equipamento.configuracaoId}`;
    }
    if (equipamento.tipo === 'I' || equipamento.tipo === 'A') {
      return `${equipamento.titulo}`;
    }
    return '';
  }

  async function validacoesBasicasParcelas() {
    const errosRecursoProprio: string[] = [];
    const errosFinanciamento: string[] = [];
    let mensagem = '';

    if (informacaoProposta) {
      const { meioPagamento } = informacaoProposta.meioPagamento;
      let contadorRecursoProprio = 1;
      let contadorFinanciamento = 1;
      const isParcelamentoEspecial = (informacaoProposta?.parcelas ?? []).some(
        item => (item.valor ?? 0) > 0,
      );

      informacaoProposta.parcelas
        .sort((a, b) => a.id - b.id)
        .forEach(parc => {
          let numeroParcela: number | null = null;

          if (parc.meioPagamentoId === 1) {
            numeroParcela = contadorRecursoProprio;
            contadorRecursoProprio += 1;
          } else if (parc.meioPagamentoId === 2) {
            numeroParcela = contadorFinanciamento;
            contadorFinanciamento += 1;
          }

          if (numeroParcela !== null && !isParcelamentoEspecial) {
            if (
              (parc.percentual === 0 || parc.percentual === null) &&
              parc.dataPrevista === null
            ) {
              mensagem = `Parcela ${numeroParcela} está sem o percentual e sem a data.`;
            } else {
              if (parc.percentual === 0 || parc.percentual === null) {
                mensagem = `Parcela ${numeroParcela} está sem o percentual.`;
              }
              if (parc.dataPrevista === null) {
                mensagem = `Parcela ${numeroParcela} está sem a data.`;
              }
            }

            if (parc.meioPagamentoId === 1 && mensagem !== '') {
              errosRecursoProprio.push(mensagem);
            }

            if (parc.meioPagamentoId === 2 && mensagem !== '') {
              errosFinanciamento.push(mensagem);
            }

            mensagem = '';
          }
        });

      const temErro =
        errosFinanciamento.length > 0 || errosRecursoProprio.length > 0;

      if (temErro) {
        const section = (titulo: string, erros: string[]) =>
          erros.length > 0
            ? `
          <h5 style="margin: 10px 0 5px;">${titulo}</h5>
          <ul style="padding-left: 20px; margin-bottom: 10px;">
            ${erros.map(erro => `<li>${erro}</li>`).join('')}
          </ul>
          `
            : '';

        const html = `
          <div style="text-align: left; text-justify: inter-word;">
            <p>Os seguintes campos precisam ser preenchidos corretamente:</p>
            <h3 style="margin: 10px 0 5px;">Parcelas</h3>
            ${section(
              `${meioPagamento === 3 ? 'Recurso Próprio' : ''} `,
              errosRecursoProprio,
            )}
            ${section(
              `${meioPagamento === 3 ? 'Financiamento' : ''} `,
              errosFinanciamento,
            )}
          </div>
        `;

        await Swal.fire({
          title: 'Atenção!',
          html,
          icon: 'warning',
          confirmButtonText: `OK`,
          confirmButtonColor: '#d33',
        });

        return false;
      }
    }

    return true;
  }

  async function validacoesBasicas() {
    const errosMotivoOutros: string[] = [];
    const errosRecursoProprio: string[] = [];
    const errosFinanciamento: string[] = [];
    const meioPagamento = informacaoProposta?.meioPagamento.meioPagamento;

    if (informacaoProposta) {
      informacaoProposta.precificacao.forEach(val => {
        if (val.valorOutros !== 0 && val.motivoOutros === '') {
          errosMotivoOutros.push(
            `${pegarNomeEquipamento(val)} está sem o motivo outros.`,
          );
        }
      });

      if (informacaoProposta.valores.valorFinalParcelas > 0) {
        informacaoProposta.parcelas
          .sort((a, b) => a.id - b.id)
          .forEach((parc, index) => {
            if (parc.observacao === '') {
              if (parc.meioPagamentoId === 1) {
                errosRecursoProprio.push(
                  `Parcela ${index + 1} está sem o evento.`,
                );
              } else if (parc.meioPagamentoId === 2) {
                errosFinanciamento.push(
                  `Parcela ${index + 1} está sem o evento.`,
                );
              }
            }
          });
      } else if (informacaoProposta.outros?.isParcelamentoEspecial) {
        informacaoProposta.parcelas
          .filter(parc => parc.setorAtividade != null)
          .sort((a, b) => a.id - b.id)
          .forEach((parc, index) => {
            if (parc.observacao === '') {
              if (parc.meioPagamentoId === 1) {
                errosRecursoProprio.push(
                  `Parcela ${index + 1} está sem o evento.`,
                );
              } else if (parc.meioPagamentoId === 2) {
                errosFinanciamento.push(
                  `Parcela ${index + 1} está sem o evento.`,
                );
              }
            }
          });
      }
    }

    const temErro =
      errosMotivoOutros.length > 0 ||
      errosRecursoProprio.length > 0 ||
      errosFinanciamento.length > 0;

    const temErroParcelas =
      errosRecursoProprio.length > 0 || errosFinanciamento.length > 0;

    if (temErro) {
      const section = (titulo: string, erros: string[]) =>
        erros.length > 0
          ? `
        <h5 style="margin: 10px 0 5px;">${titulo}</h5>
        <ul style="padding-left: 20px; margin-bottom: 10px;">
          ${erros.map(erro => `<li>${erro}</li>`).join('')}
        </ul>
      `
          : '';

      const html = `
      <div style="text-align: left; text-justify: inter-word;">
        <p>Os seguintes campos precisam ser preenchidos corretamente:</p>
        <h3 style="margin: 10px 0 5px;">Resumo</h3>
        ${section('Motivo Outros', errosMotivoOutros)}
        ${
          temErroParcelas ? `<h3 style="margin: 10px 0 5px;">Parcelas</h3>` : ''
        }
        ${section(
          `${meioPagamento === 3 ? 'Recurso Próprio' : ''} `,
          errosRecursoProprio,
        )}
        ${section(
          `${meioPagamento === 3 ? 'Financiamento' : ''} `,
          errosFinanciamento,
        )}
      </div>
    `;

      await Swal.fire({
        title: 'Atenção!',
        html,
        icon: 'warning',
        confirmButtonText: `OK`,
        confirmButtonColor: '#d33',
      });

      return false;
    }

    return true;
  }

  async function handleSave() {
    const retorno = await validacoesBasicas();
    if (!retorno) {
      setErroPosSalvar(true);
      return;
    }
    const valor = await Swal.fire({
      title: `Salvar alterações`,
      html: `<div style='text-align: justify!important; text-justify: inter-word;'>
              Ao prosseguir, as informações passarão por validações, se for necessário passar por processo de aprovação, você terá a opção de prosseguir ou não com o salvamento.
              Deseja prosseguir?</div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, prosseguir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    });

    if (valor.isConfirmed) {
      await handleSalvar();
    }
  }

  async function handleRecalculate() {
    const retorno = await validacoesBasicasParcelas();
    if (!retorno) {
      setErroPosSalvar(true);
      return;
    }
    try {
      Swal.fire({
        icon: 'info',
        text: `Recalculando proposta com os novos valores. Por favor, aguarde...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      // if (informacaoProposta) {
      //   informacaoProposta.valores.percentualServicos = 0;
      // }

      const response = await api.post(
        `/proposta-precificacao/versao/${propostaVersao.id}/calcular`,
        {
          ...informacaoProposta,
        },
      );
      setInformacaoProposta(response.data as iPropostaDados);

      carregaPropostaVersao();
      // Após o cálculo, posso habilitar o botão para salvar
      setEnableSaveButton(true);
      toast.success('Proposta calculada');
      Swal.close();
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    }
  }

  async function handleChange(newObject: iPropostaDados) {
    setInformacaoProposta(newObject);
    // sempre que houver mudanças aqui, vou desabilitar o botão de salvar. O usuário precisa calcular primeiro
    setEnableSaveButton(false);
  }

  console.log({
    informacaoProposta,
  });

  return (
    <>
      <Card className="shadow mt-1 mb-1">
        <CardBody>
          <Row className="">
            <Col sm="12" hidden={!isModoSimulacao}>
              <Alert color="warning">
                <p>
                  Estando em modo de simulação, as alterações só terão efeito
                  após salvar.
                </p>
              </Alert>
            </Col>
            <Col
              sm="12"
              hidden={
                !(
                  informacaoProposta?.valores.percentualTaxaFlat === 0 &&
                  informacaoProposta?.meioPagamento?.meioPagamento != null &&
                  informacaoProposta?.meioPagamento?.meioPagamento !== 1 &&
                  listaTaxaFlat.some(
                    banco =>
                      banco.codigoBanco ===
                        informacaoProposta?.meioPagamento?.bancoProposta &&
                      banco.formato ===
                        informacaoProposta?.meioPagamento?.formatoBanco,
                  )
                )
              }
            >
              <Alert color="danger">
                <p>O percentual de taxa flat está zerado.</p>
              </Alert>
            </Col>
            <Col
              xs="12"
              hidden={
                (informacaoProposta?.valores.percentualServicos !== 0 &&
                  informacaoProposta?.valores.percentualFrete !== 0) ||
                informacaoProposta.isExterior ||
                informacaoProposta.outros?.isRegramentoGeral
              }
            >
              <Alert color="danger">
                {(() => {
                  const zerados: string[] = [];

                  if (informacaoProposta?.valores.percentualServicos === 0) {
                    zerados.push('M.O');
                  }

                  if (informacaoProposta?.valores.percentualFrete === 0) {
                    zerados.push('frete');
                  }

                  if (zerados.length === 1) {
                    return `O percentual de ${zerados[0]} está zerado.`;
                  }

                  return `Os percentuais de ${zerados.join(
                    ', ',
                  )} estão zerados.`;
                })()}
              </Alert>
            </Col>
            <Col sm="8">
              <Button
                size="sm"
                className="btn-icon"
                color="info"
                type="button"
                hidden={isModoSimulacao}
                disabled={isSaving}
                onClick={() => handleSimulationMode(!isModoSimulacao)}
              >
                <span className="btn-inner--text">Iniciar Modo Simulação</span>
              </Button>
              <Button
                size="sm"
                className="btn-icon"
                color="danger"
                type="button"
                hidden={!isModoSimulacao}
                disabled={isSaving}
                onClick={() => handleSimulationMode(!isModoSimulacao)}
              >
                <span className="btn-inner--text">Cancelar Simulação</span>
              </Button>
            </Col>
            <Col sm="4">
              <Button
                size="sm"
                className="btn-icon float-right"
                color="success"
                type="button"
                hidden={!isModoSimulacao || !enableSaveButton}
                disabled={isSaving || isLoading || !enableSaveButton}
                onClick={handleSave}
              >
                <span className="btn-inner--text">Salvar Modificações</span>
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {informacaoProposta && (
        <>
          <Cabecalho
            propostaVersao={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            acessoPrograma={acessoProgramas}
          />

          <Resumo
            informacaoProposta={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            erroPosSalvar={erroPosSalvar}
            ordemSalvaVersion={ordemSalvaVersion}
          />

          {/* <NovoLayout
            informacaoProposta={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            erroPosSalvar={erroPosSalvar}
          /> */}

          <Desconto
            propostaVersao={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            acessoPrograma={acessoProgramas}
          />

          <MeioPagamento
            propostaVersao={informacaoProposta}
            bancosFinanciamento={bancosFinanciamento}
            formatoBanco={formatoBanco}
            propostaLinhaCredito={propostaLinhaCredito}
            meioPagamentos={meioPagamentos}
            isModoSimulacao={isModoSimulacao}
            listaFlat={listaTaxaFlat}
            onChange={handleChange}
            acessoPrograma={acessoProgramas}
          />

          <VariaveisComerciais
            propostaVersao={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            acessoPrograma={acessoProgramas}
            parametros={parametros}
            isRegramentoGeral={isRegramentoGeral}
            tipoGerar={tipoGerar}
          />

          <PrazoMedio
            propostaVersao={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            acessoPrograma={acessoProgramas}
            listaDifal={listaDifal}
          />

          <Parcelas
            propostaVersao={informacaoProposta}
            isModoSimulacao={isModoSimulacao}
            onChange={handleChange}
            isAnalisador={false}
            acessoPrograma={acessoProgramas}
            erroPosSalvar={erroPosSalvar}
          />
        </>
      )}

      <FloatingButton
        className="mb-6"
        color="primary"
        hidden={!isModoSimulacao}
        onClick={handleRecalculate}
        title="Calcular a proposta utilizando os dados informados"
      >
        <FaCalculator />
      </FloatingButton>
    </>
  );
}
